export default class MapHotelsStore {
    #data

	constructor() {
        this.#data = [...document.querySelectorAll('.js-bhotel-item')].map(hotel => {
            return {
                id: hotel.dataset.bhotelId || '',
                lat: hotel.dataset.lat || '',
                lng: hotel.dataset.lng || '',
                number: hotel.dataset.number || ''
            }
        })
    }

    getData() {
        return this.#data;
    }

    getCoordinates() {
        return this.#data.filter(item => (item.lng && item.lat)).map(item => [item.lng, item.lat]);
    }

    findHotelByID(id) {
        return this.#data.find(hotel => hotel.id === +id)
    }
}
